export default "__VITE_ASSET__BELxhmGZ__"